module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8003.b0150488.png";